import '../scss/offer-details.scss';

import {
  getLanguageISO
} from 'application/src/js/functions.js';

import {
  ModalWindow,
  Pagination,
  SpinnerOverlay
} from 'application/src/js/util.js';

import settings from 'application/src/js/settings.js';
import HorizontalMenuBar from 'application/src/js/util/horizontal-menu-bar.js';
import Notifications from 'application/src/js/ui-collection/notifications.js';

import ImagePreview from './image-preview/image-preview.js';
import SendOfferModal from './contact-modal/send-offer-modal.js';
import AnswerOfferModal from './contact-modal/answer-offer-modal.js';
import OfferSettingsModal from './offer-details/offer-settings-modal.js';
import DeleteOfferModal from './offer-details/delete-offer-modal.js';
import StatisticsModal from './offer-details/statistics-modal.js';
import OfferViewsList from './offer-details/offer-views.js';
import DeliveryCostsModal from './offer-details/modal-delivery-costs.js';

const notify = new Notifications(settings.uic.notifications);

window.addEventListener('DOMContentLoaded', _ => {
  // Modal Window for sending offers (request details page only!)
  const sendOfferModalElement = document.querySelector('#send-offer-modal');
  const openSendOfferModalButton = document.querySelectorAll('.open-send-offer-modal');

  if (openSendOfferModalButton.length && sendOfferModalElement) {
    new SendOfferModal({
      modal: new ModalWindow(sendOfferModalElement, {
        openButton: openSendOfferModalButton,
        zIndex: 1010,
        backgroundIsCloseTrigger: true,
      }),
      loader: new SpinnerOverlay({
        targetContainer: sendOfferModalElement.querySelector('.modal-body')
      }),
    });
  }

  // Modal Window for sending and answering to an offer (request details page only!)
  const answerOfferModalElement = document.querySelector('#modal-answer-offer');
  if (answerOfferModalElement) {
    new AnswerOfferModal({
      modal: new ModalWindow(answerOfferModalElement, {
        zIndex: 1010,
        backgroundIsCloseTrigger: true,
      }),
      loader: new SpinnerOverlay({
        targetContainer: answerOfferModalElement.querySelector('.modal-body')
      }),
    });
  }

  // Modal Window for quick settings (dynamic/contract offers only!)
  const offerSettingsModalElement = document.querySelector('#modal-offer-settings');
  if (offerSettingsModalElement) {
    const offerSettingsModal = new OfferSettingsModal({
      modal: new ModalWindow(offerSettingsModalElement, {
        zIndex: 1010,
        backgroundIsCloseTrigger: true,
      }),
      loader: new SpinnerOverlay({
        targetContainer: offerSettingsModalElement.querySelector('.modal-body')
      }),
    });

    offerSettingsModal.subscribe('saved', settings => {
      [...document.querySelectorAll('offer-ribbon')].map(ribbon => {
        ribbon.setAttribute('type', settings.highlighting_type);
      });
    });
  }

  new DeleteOfferModal({
    modal: new ModalWindow(document.querySelector('#modal-delete-offer'))
  });

  // after creating an offer/request show modal window for sending it in an email
  if (document.referrer && document.referrer.match(/(\/addOffer|\/addRequest)$/) !== null) {
    new ModalWindow(document.querySelector('.modal-send-offer-mailing-info'), {
      openOnInit: true,
      backgroundIsCloseTrigger: false
    });
  }

  new HorizontalMenuBar({
    element: document.querySelector('main .horizontal-menu-bar')
  });

  new ImagePreview();

  new OfferViewsList({
    container: document.querySelector('.component.offer-views'),
    translations: translations,
    pagination: new Pagination({
      container: document.querySelector('.component.offer-views .pagination'),
      noResultsMessage: document.querySelector('.component.offer-views .no-results-error'),
      minimize: true
    })
  });

  new DeliveryCostsModal({
    modal: new ModalWindow(document.querySelector('#modal-delivery-costs')),
    notify: notify
  });

  if (document.querySelector('.open-request-freight-charges')) {
    import( /* webpackChunkName: "od-request-freight-charges" */ 'application/src/js/logistics/request-freight-charges.js')
      .then(({
        default: RequestFreightCharges
      }) => {
        const requestFreightCharges = new RequestFreightCharges(Object.assign({}, { isModal: true }, requestFreightChargesConfig));

        const openButton = document.querySelector('.open-request-freight-charges');
        openButton.classList.remove('hide');

        requestFreightCharges.subscribe('init', _ => {
          openButton.addEventListener('click', _ => requestFreightCharges.modal.open());
        });
      });
  }

  new StatisticsModal({
    modal: new ModalWindow(document.querySelector('#modal-statistics')),
    statisticData: typeof phpObj !== 'undefined' ? phpObj : null
  });

  new AvailableOfferQuantity({
    translations: translations
  });
});

/**
 * @description observe the place-order component in order to get notified when the total number of delivery units changes
 * @param {object} translations
 */
class AvailableOfferQuantity {
  constructor(args) {
    this.translations = args.translations;
    this.placeOfferComponent = document.querySelector('.details-component place-order');

    if (!this.placeOfferComponent) return;

    this.container = document.querySelector('.details-main-column');
    this.quantityOut = this.container.querySelector('.available-quantity-out');

    this.addEvents();
    this.update(this.placeOfferComponent);
  }

  addEvents() {
    const observer = new MutationObserver(mutations => mutations.map(mutation => this.update(this.placeOfferComponent)));
    observer.observe(this.placeOfferComponent, {
      attributes: true,
      attributeFilter: ['total-units']
    });
  }

  update() {
    const availableUnits = parseFloat(this.placeOfferComponent.getAttribute('total-units'));
    const quantityPerUnit = parseFloat(this.placeOfferComponent.getAttribute('quantity-per-unit'));
    const packageWeight = parseFloat(this.placeOfferComponent.getAttribute('package-weight'));
    const measurement = this.placeOfferComponent.getAttribute('measurement');
    const calcTotal = !!this.quantityOut.getAttribute('data-calc-total');

    new Intl.NumberFormat(getLanguageISO(), {
      style: 'decimal'
    }).format(availableUnits)

    if (availableUnits && quantityPerUnit && packageWeight) {
      this.quantityOut.innerHTML = `
        ${new Intl.NumberFormat(getLanguageISO(), { style: 'decimal' }).format(availableUnits)}
        ${availableUnits == 1 ? this.translations.deliveryUnit : this.translations.deliveryUnits}

        ${parseInt(calcTotal) ? `
          (${new Intl.NumberFormat(getLanguageISO(), { style: 'decimal' }).format(availableUnits * quantityPerUnit * packageWeight)} ${measurement})
        ` : ''}
      `;
    }
  }
}